// Magnetic Flux Density units with conversion factors to tesla (T)
export const magneticFluxDensityUnits = [
  { id: 'tesla', name: 'Tesla', symbol: 'T', plural: 'Teslas', factor: 1 },
  { id: 'millitesla', name: 'Millitesla', symbol: 'mT', plural: 'Milliteslas', factor: 1e-3 },
  { id: 'microtesla', name: 'Microtesla', symbol: 'µT', plural: 'Microteslas', factor: 1e-6 },
  { id: 'nanotesla', name: 'Nanotesla', symbol: 'nT', plural: 'Nanoteslas', factor: 1e-9 },
  { id: 'gauss', name: 'Gauss', symbol: 'G', plural: 'Gauss', factor: 1e-4 },
  { id: 'milligauss', name: 'Milligauss', symbol: 'mG', plural: 'Milligauss', factor: 1e-7 },
  { id: 'weber-per-sqmeter', name: 'Weber/Square Meter', symbol: 'Wb/m²', plural: 'Webers/Square Meter', factor: 1 },
  { id: 'weber-per-sqcm', name: 'Weber/Square Centimeter', symbol: 'Wb/cm²', plural: 'Webers/Square Centimeter', factor: 1e4 },
  { id: 'maxwell-per-sqcm', name: 'Maxwell/Square Centimeter', symbol: 'Mx/cm²', plural: 'Maxwells/Square Centimeter', factor: 1e-4 },
  { id: 'line-per-sqcm', name: 'Line/Square Centimeter', symbol: 'line/cm²', plural: 'Lines/Square Centimeter', factor: 1e-4 },
  { id: 'gamma', name: 'Gamma', symbol: 'γ', plural: 'Gammas', factor: 1e-9 },
];

export const popularMagneticFluxDensityConversions = [
  { from: 'tesla', to: 'gauss' },
  { from: 'gauss', to: 'tesla' },
  { from: 'tesla', to: 'millitesla' },
  { from: 'millitesla', to: 'tesla' },
  { from: 'tesla', to: 'microtesla' },
  { from: 'microtesla', to: 'nanotesla' },
];

export const getUnitById = (id) => magneticFluxDensityUnits.find(unit => unit.id === id);

export const convertMagneticFluxDensity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert magnetic flux density units and learn the conversion formula.`;
};
